export const FETCH_INTERVIEWS_LIST_REQUESTED =
  "FETCH_INTERVIEWS_LIST_REQUESTED";
export const FETCH_INTERVIEWS_LIST_FAILED = "FETCH_INTERVIEWS_LIST_FAILED";
export const FETCH_INTERVIEWS_LIST_SUCCEEDED =
  "FETCH_INTERVIEWS_LIST_SUCCEEDED";
export const SET_FORMATTED_INTERVIEWS = "SET_FORMATTED_INTERVIEWS";
export const SET_FILTERED_INTERVIEWS = "SET_FILTERED_INTERVIEWS";
export const UPDATE_INTERVIEWS_FILTERS = "UPDATE_INTERVIEWS_FILTERS";
export const SET_ITEMS_VALUES = "SET_ITEMS_VALUES";
export const SET_TABS = "SET_TABS";
export const SET_PAYMENT_STATUS_FILTER = "SET_PAYMENT_STATUS_FILTER";
export const INVALIDATE_INTERVIEW_REQUESTED = "INVALIDATE_INTERVIEW_REQUESTED";
export const INVALIDATE_INTERVIEW_SUCCEEDED = "INVALIDATE_INTERVIEW_SUCCEEDED";
export const INVALIDATE_INTERVIEW_FAILED = "INVALIDATE_INTERVIEW_FAILED";
export const MARK_INTERVIEW_RESCHEDULED = "MARK_INTERVIEW_RESCHEDULED";
export const FETCH_AVAILABLE_MODERATORS_REQUESTED =
  "FETCH_AVAILABLE_MODERATORS_REQUESTED";
export const FETCH_AVAILABLE_MODERATORS_SUCCEEDED =
  "FETCH_AVAILABLE_MODERATORS_SUCCEEDED";
export const FETCH_AVAILABLE_MODERATORS_FAILED =
  "FETCH_AVAILABLE_MODERATORS_FAILED";
export const REASSIGN_MODERATOR_REQUESTED = "REASSIGN_MODERATOR_REQUESTED";
export const REASSIGN_MODERATOR_SUCCEEDED = "REASSIGN_MODERATOR_SUCCEEDED";
export const REASSIGN_MODERATOR_FAILED = "REASSIGN_MODERATOR_FAILED";
// Mark a specific interview's reschedule email as sent (used to disable button immediately)
export const MARK_INVALIDATE_EMAIL_SENT_FOR_TIMESLOT =
  "MARK_INVALIDATE_EMAIL_SENT_FOR_TIMESLOT";
